import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=3d12f090&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d12f090')) {
      api.createRecord('3d12f090', component.options)
    } else {
      api.reload('3d12f090', component.options)
    }
    module.hot.accept("./Share.vue?vue&type=template&id=3d12f090&", function () {
      api.rerender('3d12f090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/SettingRenew/Contents/Share.vue"
export default component.exports